module.exports = __webpack_public_path__ + "img/fr_242_btn2.d15dc193.png";